import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";

// styles
import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss?v=1.2.0";
import "assets/demo/demo.css?v=1.2.0";
// pages
// import Home from "./views/Home.js";
// import Contact from './views/Contact';
// core
import Navbar from './components/Navbars/Navbar';
import Footer from './components/Footers/Footer';
import InstagramScrapper from './components/Sections/InstagramScrapper';

// Lazy pages
const Home = lazy(() => import('./views/Home'));
const Contact = lazy(() => import('./views/Contact'));

ReactDOM.render(
  <BrowserRouter>
    <Navbar />

    <Switch>

      <Route path="/" exact render={(props) => <Suspense fallback={<p>Cargando...</p>}><Home {...props} /></Suspense>} />
      <Route path="/contacto" render={(props) => <Suspense fallback={<p>Cargando...</p>}><Contact {...props} /></Suspense>} />
      <Redirect to="/" />
      
    </Switch>

    <InstagramScrapper />
    <Footer />
  </BrowserRouter>,
  document.getElementById("root")
);
